import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'
import { IconButton, Box } from '@mui/material'

import useGoToFile from './useGoToFile'

type Props = {
  objIDs: string[] | null
  currentIdx: number
  setOIdx: (idx: number) => void
}

export default function MultiDocNav({ objIDs, currentIdx, setOIdx }: Props) {
  const goToFile = useGoToFile(setOIdx)

  const isMulti = objIDs && objIDs.length > 1
  const prevDisabled = currentIdx === 0
  const nextDisabled = !objIDs || objIDs.length - 1 <= currentIdx

  const handlePrevBtnClick = () => {
    goToFile(currentIdx - 1)
  }

  const handleNextBtnClick = () => {
    goToFile(currentIdx + 1)
  }

  if (!isMulti) return null

  return (
    <Box
      sx={{
        flexShrink: 0,
        mr: 2,
      }}
    >
      <IconButton
        color="secondary"
        size="small"
        disabled={prevDisabled}
        onClick={handlePrevBtnClick}
      >
        <ChevronLeftOutlinedIcon />
      </IconButton>
      <IconButton
        color="secondary"
        size="small"
        disabled={nextDisabled}
        onClick={handleNextBtnClick}
      >
        <ChevronRightOutlinedIcon />
      </IconButton>
    </Box>
  )
}
